// // import React, { useRef } from 'react';
// // import { Card, Row, Col, Container } from "react-bootstrap";
// // import certificate from "../../assets/images/Patents & IPs.jpg";
// // import wideangle from "../../assets/images/State of the art.jpg";
// // import { Swiper, SwiperSlide } from 'swiper/react';
// // import { Autoplay } from 'swiper/modules';


// // import 'bootstrap/dist/css/bootstrap.min.css';
// // import 'swiper/css';

// // const WhyChooseGautamSolar = () => {

// //   const sliderRef=useRef();

// //   const img1 = [
// //     { img: '/Bis.png' },
// //     { img: '/CE.png' },
// //     { img: '/IEC.png' },
// //     { img: '/SGS.png' },
// //     { img: '/TUV.png' },
// //     { img: '/UL.png' }
// //   ];

// //   const img2 = [
// //     // { img: '/1.webp' },

// //     {img:'/ozoneCert.webp'},
// //     {img:'/kiwi_cert.png'},
// //     {img:'/certificate.webp'},
// //     {img:'/certificate2.webp'},
// //     {img:'/certificate3.webp'},
// //     { img: '/2.webp' },
// //     { img: '/3.webp' },
// //     // { img: '/4.webp' },
// //     // { img: '/5.webp' },
// //     { img: '/6.webp' },
// //     { img: '/Asset 20.webp' },
// //     { img: '/Asset 10.webp' },
// //     { img: '/Asset 30.webp' },
// //     { img: '/Asset 40.webp' },

// //   ];


// //   return (
// //     <section className="py-5 text-center container border-top position-relative" >
// //       <div>
// //         <div className="col-lg-9 col-md-8 mx-auto text-center">
// //           <h2 className="textRes" style={{ position: 'relative', color: "black" }}>
// //             <span style={{
// //               position: 'absolute',
// //               top: '-15px',
// //               left: '50%',
// //               transform: 'translateX(-50%)',
// //               borderBottom: '2px solid #faab04',
// //               width: '50px',
// //             }}></span>
// //             WHY <span style={{ fontWeight: 'bold', color: '#a20000' }}>CHOOSE GAUTAM SOLAR</span>
// //           </h2>
// //         </div>
// //       </div>

// //       <Container className="my-5 px-3 text-center">
// //         <Row className="elementor-row">
// //           <Col md={6} className="elementor-column elementor-col-12 mb-4">
// //             <Card className="elementor-widget elementor-widget-image text-center h-100">

// //               <img
// //                 style={{ width: '100%', height: '100%' }}
// //                 // variant="top"
// //                 src={wideangle}
// //                 className="img-fluid "
// //                 alt="Multiple Factories"
// //                 width={500}
// //                 height={500}
// //                 loading='lazy'
// //               />
// //               <Card.Body>
// //                 <Card.Title style={{ color: "black", fontSize: '14.5px', fontWeight: '700' }}>

// //                   Fully Automated Setup
// //                 </Card.Title>
// //                 <Card.Text style={{ textAlign: "center", lineHeight: "1.5", color: 'black', fontWeight: '300', fontSize: '18px' }}>
// //                   Multiple Factories
// //                 </Card.Text>
// //               </Card.Body>
// //             </Card>
// //           </Col>
// //           <Col md={6} className="elementor-column elementor-col-12 mb-4">
// //             <Card className="elementor-widget elementor-widget-image text-center h-100">
// //               <img
// //                 style={{ width: '100%', height: '100%' }}
// //                 // variant="top"
// //                 src={certificate}
// //                 className="img-fluid"
// //                 alt="Patents & IPs"
// //                 width={500}
// //                 height={500}
// //                 loading='lazy'
// //               />
// //               <Card.Body>
// //                 <Card.Title style={{ color: "black", fontSize: '14.5px', fontWeight: '700' }}>
// //                   Strong focus on R&D and
// //                   indigenous innovation in the Solar Industry
// //                 </Card.Title>
// //                 <Card.Text style={{ textAlign: "center", lineHeight: "1.5", color: 'black', fontWeight: '300', fontSize: '18px' }}>
// //                   Patents & IPs
// //                 </Card.Text>
// //               </Card.Body>
// //             </Card>
// //           </Col>
// //         </Row>
// //       </Container>

// //       {/* Quality and Certification */}

// //       <Container className="py-5 border-top my-4">
// //         <h2 className="text-center mb-4 text-uppercase textRes">
// //           Quality & <span style={{ color: '#a20000' }}> Certification</span>
// //         </h2>

// //         {/* First Slider */}
// //         <div className='border'>
// //           <Swiper
// //             spaceBetween={10}
// //             slidesPerView={2}
// //             autoplay={{
// //               delay: 100,
// //               disableOnInteraction: false,
// //             }}
// //             modules={[Autoplay]}
// //             loop={true}
// //             speed={2000}
// //             breakpoints={{
// //               1200: { slidesPerView: 4 },
// //               992: { slidesPerView: 3 },
// //               768: { slidesPerView: 2 },
// //               576: { slidesPerView: 2 },
// //             }}
// //             lazy={true}
// //           >
// //             {img1.map((item, index) => (
// //               <SwiperSlide key={index} >
// //                 <div
// //                   className="bg-white rounded-lg shadow-sm d-flex align-items-center justify-content-center"
// //                   style={{ height: '100px' }}
// //                 >
// //                   <img
// //                     src={item.img}
// //                     alt={`Cert ${index + 1}`}
// //                     style={{ width: '90px', objectFit: 'cover' }}
// //                     loading='lazy'
// //                   />
// //                 </div>
// //               </SwiperSlide>
// //             ))}
// //           </Swiper>
// //         </div>

// //         {/* Second Slider */}
// //         <div className="mt-4 border rounded-lg " >
// //           <Swiper
// //             ref={sliderRef}
// //             spaceBetween={10}
// //             autoplay={{
// //               delay: 500,
// //               disableOnInteraction: false,
// //             }}
// //             modules={[Autoplay]}
// //             loop={true}
// //             speed={3000}
// //             breakpoints={{
// //               1200: { slidesPerView: 3 },
// //               992: { slidesPerView: 2 },
// //               768: { slidesPerView: 1 },
// //               576: { slidesPerView: 1 },
// //             }}
// //             lazy={true}
// //           >
// //             {img2.map((item, index) => (
// //               <SwiperSlide key={index} onMouseEnter={()=>sliderRef.current.swiper.autoplay.stop()} onMouseLeave={()=>sliderRef.current.swiper.autoplay.start()}>
// //                 <div className="bg-white p-1 border d-flex align-items-center justify-content-center" >
// //                   <img
// //                     className='rounded '
// //                     src={item.img}
// //                     alt={`Media ${index + 1}`}
// //                     loading='lazy'
// //                     style={{ maxWidth: '100%', objectFit: 'contain', borderRadius: '12px',height:'400px' }}
// //                   />
// //                 </div>
// //               </SwiperSlide>
// //             ))}
// //           </Swiper>
          
// //         </div>
// //       </Container>
// //     </section>
// //   );
// // };

// // export default WhyChooseGautamSolar;


// import React, { useRef } from 'react';
// import { Card, Row, Col, Container } from "react-bootstrap";
// import certificate from "../../assets/images/Patents & IPs.webp";
// import wideangle from "../../assets/images/State of the art.webp";
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Pagination } from 'swiper/modules';


// import 'swiper/css';
// import 'swiper/css/pagination';

// const WhyChooseGautamSolar = () => {

//   const sliderRef = useRef();

//   const img1 = [
//     { img: '/Bis.png' },
//     { img: '/CE.png' },
//     { img: '/IEC.png' },
//     { img: '/SGS.png' },
//     { img: '/TUV.png' },
//     { img: '/UL.png' }
//   ];

//   const img2 = [
//     { img: '/inverter01.webp' },
//     { img: '/inverter02.webp' },
//     { img: '/ozoneCert.webp' },
//     { img: '/kiwi_cert.png' },
//     { img: '/certificate.webp' },
//     { img: '/certificate2.webp' },
//     { img: '/certificate3.webp' },
//     { img: '/2.webp' },
//     { img: '/3.webp' },
//     { img: '/6.webp' },
//     { img: '/Asset 20.webp' },
//     { img: '/Asset 10.webp' },
//     { img: '/Asset 30.webp' },
//     { img: '/Asset 40.webp' },
//   ];

//   return (
//     <section className="py-5 text-center container border-top position-relative">
//       <div>
//         <div className="col-lg-9 col-md-8 mx-auto text-center">
//           <h2 className="textRes" style={{ position: 'relative', color: "black" }}>
//             <span style={{
//               position: 'absolute',
//               top: '-15px',
//               left: '50%',
//               transform: 'translateX(-50%)',
//               borderBottom: '2px solid #faab04',
//               width: '50px',
//             }}></span>
//             WHY <span style={{ fontWeight: 'bold', color: '#a20000' }}>CHOOSE GAUTAM SOLAR</span>
//           </h2>
//         </div>
//       </div>

//       <Container className="my-5 px-3 text-center">
//         <Row className="elementor-row">
//           <Col md={6} className="elementor-column elementor-col-12 mb-4">
//             <Card className="elementor-widget elementor-widget-image text-center h-100">
//               <img
//                 style={{ width: '100%', height: '100%' }}
//                 src={wideangle}
//                 className="img-fluid "
//                 alt="Multiple Factories"
//                 width={500}
//                 height={500}
//                 loading='lazy'
//               />
//               <Card.Body>
//                 <Card.Title style={{ color: "black", fontSize: '14.5px', fontWeight: '700' }}>
//                   Fully Automated Setup
//                 </Card.Title>
//                 <Card.Text style={{ textAlign: "center", lineHeight: "1.5", color: 'black', fontWeight: '300', fontSize: '18px' }}>
//                   Multiple Factories
//                 </Card.Text>
//               </Card.Body>
//             </Card>
//           </Col>
//           <Col md={6} className="elementor-column elementor-col-12 mb-4">
//             <Card className="elementor-widget elementor-widget-image text-center h-100">
//               <img
//                 style={{ width: '100%', height: '100%' }}
//                 src={certificate}
//                 className="img-fluid"
//                 alt="Patents & IPs"
//                 width={500}
//                 height={500}
//                 loading='lazy'
//               />
//               <Card.Body>
//                 <Card.Title style={{ color: "black", fontSize: '14.5px', fontWeight: '700' }}>
//                   Strong focus on R&D and
//                   indigenous innovation in the Solar Industry
//                 </Card.Title>
//                 <Card.Text style={{ textAlign: "center", lineHeight: "1.5", color: 'black', fontWeight: '300', fontSize: '18px' }}>
//                   Patents & IPs
//                 </Card.Text>
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Container>

//       {/* Quality and Certification */}
//       <Container className="py-5 border-top my-4">
//         <h2 className="text-center mb-2 text-uppercase textRes">
//           Quality & <span style={{ color: '#a20000' }}> Certification</span>
//         </h2>
//         <p style={{ maxWidth: '640px', margin: '0 auto 40px', fontSize: '14.5px', color: '#6b7280', lineHeight: 1.6 }}>
//           Gautam Solar's modules are tested and certified to international
//           quality, safety, and performance standards, backed by independent
//           recognition from global testing bodies.
//         </p>

//         {/* Standards strip — small, dense, fast-moving trust-mark ticker.
//             These are logos people recognize at a glance, not content to
//             linger on, so the treatment stays compact and quiet. */}
//         <div
//           style={{
//             background: '#fff',
//             border: '1px solid #E5E7EB',
//             borderRadius: '14px',
//             padding: '28px 20px',
//             marginBottom: '48px',
//           }}
//         >
//           <Swiper
//             spaceBetween={16}
//             slidesPerView={2}
//             autoplay={{ delay: 1800, disableOnInteraction: false }}
//             modules={[Autoplay]}
//             loop={true}
//             speed={2000}
//             breakpoints={{
//               1200: { slidesPerView: 6 },
//               992: { slidesPerView: 4 },
//               768: { slidesPerView: 3 },
//               576: { slidesPerView: 2 },
//             }}
//           >
//             {img1.map((item, index) => (
//               <SwiperSlide key={index}>
//                 <div
//                   className="d-flex align-items-center justify-content-center"
//                   style={{ height: '90px' }}
//                 >
//                   <img
//                     src={item.img}
//                     alt={`Certification standard ${index + 1}`}
//                     loading="lazy"
//                     style={{ maxWidth: '85px', maxHeight: '70px', width: 'auto', height: 'auto', objectFit: 'contain', filter: 'grayscale(15%)' }}
//                   />
//                 </div>
//               </SwiperSlide>
//             ))}
//           </Swiper>
//         </div>

//         {/* Certificate showcase — one framed credential at a time, given real
//             visual presence like something worth displaying on a wall, not a
//             product to compare against others. */}
//         <div
//           style={{
//             background: '#FAFAFA',
//             border: '1px solid #E5E7EB',
//             borderRadius: '18px',
//             padding: '36px 24px',
//             position: 'relative',
//           }}
//         >
//           <span
//             style={{
//               position: 'absolute',
//               top: '20px',
//               left: '50%',
//               transform: 'translateX(-50%)',
//               background: '#a20000',
//               color: '#fff',
//               fontSize: '11px',
//               fontWeight: 700,
//               padding: '5px 16px',
//               borderRadius: '999px',
//               letterSpacing: '0.5px',
//               textTransform: 'uppercase',
//               zIndex: 2,
//             }}
//           >
//             Certified Recognition
//           </span>

//           <Swiper
//             ref={sliderRef}
//             spaceBetween={24}
//             slidesPerView={1}
//             autoplay={{ delay: 3200, disableOnInteraction: false }}
//             pagination={{ clickable: true }}
//             modules={[Autoplay, Pagination]}
//             loop={true}
//             speed={900}
//             breakpoints={{
//               1200: { slidesPerView: 2 },
//               768: { slidesPerView: 1 },
//             }}
//             style={{ '--swiper-pagination-color': '#a20000',
//     '--swiper-pagination-bullet-inactive-color': '#d1d5db',
//     '--swiper-pagination-bullet-inactive-opacity': '1',paddingTop: '20px', paddingBottom: '48px' }}
//             onMouseEnter={() => sliderRef.current?.swiper?.autoplay?.stop()}
//             onMouseLeave={() => sliderRef.current?.swiper?.autoplay?.start()}
//           >
//             {img2.map((item, index) => (
//               <SwiperSlide key={index}>
//                 <div
//                   style={{
//                     background: '#fff',
//                     borderRadius: '14px',
//                     border: '1px solid #E5E7EB',
//                     boxShadow: '0 8px 24px -8px rgba(0,0,0,0.08)',
//                     padding: '20px',
//                     height: '380px',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                   }}
//                 >
//                   <img
//                     src={item.img}
//                     alt={`Certification credential ${index + 1}`}
//                     loading="lazy"
//                     style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', objectFit: 'contain', borderRadius: '8px' }}
//                   />
//                 </div>
//               </SwiperSlide>
//             ))}
//           </Swiper>
//         </div>
//       </Container>
//     </section>
//   );
// };

// export default WhyChooseGautamSolar;

import React, { useRef, useState, useEffect } from 'react';
import { Card, Row, Col, Container } from "react-bootstrap";
import certificate from "../../assets/images/Patents & IPs.webp";
import wideangle from "../../assets/images/State of the art.webp";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';


import 'swiper/css';
import 'swiper/css/pagination';

const WhyChooseGautamSolar = () => {

  const sliderRef = useRef();

  const [activeCert, setActiveCert] = useState(null);

  const img1 = [
    { img: '/Bis.png' },
    { img: '/CE.png' },
    { img: '/IEC.png' },
    { img: '/SGS.png' },
    { img: '/TUV.png' },
    { img: '/UL.png' }
  ];

  const img2 = [
    { img: '/inverter01.webp' },
    { img: '/inverter02.webp' },
    { img: '/ozoneCert.webp' },
    { img: '/kiwi_cert.png' },
    { img: '/certificate.webp' },
    { img: '/certificate2.webp' },
    { img: '/certificate3.webp' },
    { img: '/2.webp' },
    { img: '/3.webp' },
    { img: '/6.webp' },
    { img: '/Asset 20.webp' },
    { img: '/Asset 10.webp' },
    { img: '/Asset 30.webp' },
    { img: '/Asset 40.webp' },
  ];

  // Close modal on Escape key
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setActiveCert(null); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  // Lock body scroll while modal is open
  useEffect(() => {
    if (activeCert) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = prev; };
    }
  }, [activeCert]);

  return (
    <section className="py-5 text-center container border-top position-relative">
      <div>
        <div className="col-lg-9 col-md-8 mx-auto text-center">
          <h2 className="textRes" style={{ position: 'relative', color: "black" }}>
            <span style={{
              position: 'absolute',
              top: '-15px',
              left: '50%',
              transform: 'translateX(-50%)',
              borderBottom: '2px solid #faab04',
              width: '50px',
            }}></span>
            WHY <span style={{ fontWeight: 'bold', color: '#a20000' }}>CHOOSE GAUTAM SOLAR</span>
          </h2>
        </div>
      </div>

      <Container className="my-5 px-3 text-center">
        <Row className="elementor-row">
          <Col md={6} className="elementor-column elementor-col-12 mb-4">
            <Card className="elementor-widget elementor-widget-image text-center h-100">
              <img
                style={{ width: '100%', height: '100%' }}
                src={wideangle}
                className="img-fluid "
                alt="Multiple Factories"
                width={500}
                height={500}
                loading='lazy'
              />
              <Card.Body>
                <Card.Title style={{ color: "black", fontSize: '14.5px', fontWeight: '700' }}>
                  Fully Automated Setup
                </Card.Title>
                <Card.Text style={{ textAlign: "center", lineHeight: "1.5", color: 'black', fontWeight: '300', fontSize: '18px' }}>
                  Multiple Factories
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="elementor-column elementor-col-12 mb-4">
            <Card className="elementor-widget elementor-widget-image text-center h-100">
              <img
                style={{ width: '100%', height: '100%' }}
                src={certificate}
                className="img-fluid"
                alt="Patents & IPs"
                width={500}
                height={500}
                loading='lazy'
              />
              <Card.Body>
                <Card.Title style={{ color: "black", fontSize: '14.5px', fontWeight: '700' }}>
                  Strong focus on R&D and
                  indigenous innovation in the Solar Industry
                </Card.Title>
                <Card.Text style={{ textAlign: "center", lineHeight: "1.5", color: 'black', fontWeight: '300', fontSize: '18px' }}>
                  Patents & IPs
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Quality and Certification */}
      <Container className="py-5 border-top my-4">
        <h2 className="text-center mb-2 text-uppercase textRes">
          Quality & <span style={{ color: '#a20000' }}> Certification</span>
        </h2>
        <p style={{ maxWidth: '640px', margin: '0 auto 40px', fontSize: '14.5px', color: '#6b7280', lineHeight: 1.6 }}>
          Gautam Solar's modules are tested and certified to international
          quality, safety, and performance standards, backed by independent
          recognition from global testing bodies.
        </p>

        {/* Standards strip — small, dense, fast-moving trust-mark ticker.
            These are logos people recognize at a glance, not content to
            linger on, so the treatment stays compact and quiet. */}
        <div
          style={{
            background: '#fff',
            border: '1px solid #E5E7EB',
            borderRadius: '14px',
            padding: '28px 20px',
            marginBottom: '48px',
          }}
        >
          <Swiper
            spaceBetween={16}
            slidesPerView={2}
            autoplay={{ delay: 1800, disableOnInteraction: false }}
            modules={[Autoplay]}
            loop={true}
            speed={2000}
            breakpoints={{
              1200: { slidesPerView: 6 },
              992: { slidesPerView: 4 },
              768: { slidesPerView: 3 },
              576: { slidesPerView: 2 },
            }}
          >
            {img1.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ height: '90px' }}
                >
                  <img
                    src={item.img}
                    alt={`Certification standard ${index + 1}`}
                    loading="lazy"
                    style={{ maxWidth: '85px', maxHeight: '70px', width: 'auto', height: 'auto', objectFit: 'contain', filter: 'grayscale(15%)' }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Certificate showcase — one framed credential at a time, given real
            visual presence like something worth displaying on a wall, not a
            product to compare against others. */}
        <div
          style={{
            background: '#FAFAFA',
            border: '1px solid #E5E7EB',
            borderRadius: '18px',
            padding: '36px 24px',
            position: 'relative',
          }}
        >
          <span
            style={{
              position: 'absolute',
              top: '20px',
              left: '50%',
              transform: 'translateX(-50%)',
              background: '#a20000',
              color: '#fff',
              fontSize: '11px',
              fontWeight: 700,
              padding: '5px 16px',
              borderRadius: '999px',
              letterSpacing: '0.5px',
              textTransform: 'uppercase',
              zIndex: 2,
            }}
          >
            Certified Recognition
          </span>

          <Swiper
            ref={sliderRef}
            spaceBetween={24}
            slidesPerView={1}
            autoplay={{ delay: 3200, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            modules={[Autoplay, Pagination]}
            loop={true}
            speed={900}
            breakpoints={{
              1200: { slidesPerView: 2 },
              768: { slidesPerView: 1 },
            }}
            style={{ '--swiper-pagination-color': '#a20000',
    '--swiper-pagination-bullet-inactive-color': '#d1d5db',
    '--swiper-pagination-bullet-inactive-opacity': '1',paddingTop: '20px', paddingBottom: '48px' }}
            onMouseEnter={() => sliderRef.current?.swiper?.autoplay?.stop()}
            onMouseLeave={() => sliderRef.current?.swiper?.autoplay?.start()}
          >
            {img2.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  style={{
                    background: '#fff',
                    borderRadius: '14px',
                    border: '1px solid #E5E7EB',
                    boxShadow: '0 8px 24px -8px rgba(0,0,0,0.08)',
                    padding: '20px',
                    height: '380px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'zoom-in',
                  }}
                  onClick={() => setActiveCert(item.img)}
                >
                  <img
                    src={item.img}
                    alt={`Certification credential ${index + 1}`}
                    loading="lazy"
                    style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', objectFit: 'contain', borderRadius: '8px' }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Container>

      {/* Certificate lightbox modal */}
      {activeCert && (
        <div
          onClick={() => setActiveCert(null)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.85)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            cursor: 'zoom-out',
            animation: 'fadeIn 0.2s ease',
          }}
        >
          <button
            onClick={(e) => { e.stopPropagation(); setActiveCert(null); }}
            aria-label="Close"
            style={{
              position: 'absolute',
              top: '18px',
              right: '22px',
              background: 'rgba(255,255,255,0.12)',
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '50%',
              width: '42px',
              height: '42px',
              fontSize: '22px',
              lineHeight: 1,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            ×
          </button>
          <img
            src={activeCert}
            alt="Certificate preview"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: '92vw',
              maxHeight: '90vh',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
              background: '#fff',
              borderRadius: '10px',
              boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
              cursor: 'default',
            }}
          />
        </div>
      )}
    </section>
  );
};

export default WhyChooseGautamSolar;